import React, { useReducer } from "react";
import { AuthContext } from "./auth/AuthContext";
import { AuthReducer } from "./auth/AuthReducer";
import { RouterPrincipal } from "./routers/RouterPrincipal";

function App() {
  const init = () => {
    //TODO: si no hay un token pasa el acceso falso
    return (
      JSON.parse(localStorage.getItem("tokenportafolio")) || { logged: false }
    );
  };
  // TODO: implementacion del useReducer
  const [state, dispatch] = useReducer(AuthReducer, {}, init);

  return (
    <AuthContext.Provider value={{ state, dispatch }}>
      <RouterPrincipal />
    </AuthContext.Provider>
  );
}

export default App;
